// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme--light.v-sheet--outlined{border:thin solid #2196f3}", ""]);
// Exports
module.exports = exports;
